exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.product-listing[data-v-3c1dc2b2]{margin:0}.product-listing__wrapper[data-v-3c1dc2b2]{padding-left:0;padding-right:0}}\n", ""]);

// exports
